module.exports = __webpack_public_path__ + "static/media/midnight-x.9f932657.svg";